import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

interface BurgerMenuProps {
  categories: {
    name: string;
    path: string;
  }[];
}

const BurgerMenu: React.FC<BurgerMenuProps> = ({ categories }) => {
  const [isOpen, setIsOpen] = useState(false);
  console.log('Categories in BurgerMenu:', categories);

  return (
    <div className="md:hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="p-2 text-gray-600 hover:text-indigo-600"
        aria-label={isOpen ? 'Close menu' : 'Open menu'}
      >
        {isOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {isOpen && (
        <div className="fixed top-[64px] left-0 right-0 bottom-0 bg-white border-t border-gray-200 shadow-lg z-50 overflow-y-auto">
          <nav className="px-4 py-2">
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/" 
                  className="block py-2 text-gray-600 hover:text-indigo-600"
                  onClick={() => setIsOpen(false)}
                >
                  Home
                </Link>
              </li>
              <li>
                <div className="py-2">
                  <span className="font-medium text-gray-800">Calculators</span>
                  <ul className="ml-4 mt-2 space-y-2">
                    {categories.map((category, index) => (
                      <li key={index}>
                        <Link
                          to={category.path}
                          className="block py-1 text-gray-600 hover:text-indigo-600"
                          onClick={() => setIsOpen(false)}
                        >
                          {category.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>
              <li>
                <Link 
                  to="/blog" 
                  className="block py-2 text-gray-600 hover:text-indigo-600"
                  onClick={() => setIsOpen(false)}
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link 
                  to="/glossary" 
                  className="block py-2 text-gray-600 hover:text-indigo-600"
                  onClick={() => setIsOpen(false)}
                >
                  Glossary
                </Link>
              </li>
              <li>
                <Link 
                  to="/about" 
                  className="block py-2 text-gray-600 hover:text-indigo-600"
                  onClick={() => setIsOpen(false)}
                >
                  About
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      )}
    </div>
  );
};

export default BurgerMenu;
